import React, { useState, useEffect } from 'react';
import { Select, Tooltip } from 'antd';
import { AiOutlineDelete } from 'react-icons/ai';
import './InfluencerSelectControlComponent.styles.scss';

const { Option } = Select;
const InfluencerSelectControlComponent = ({ lists, listOnChange }) => {
  // const [selVal,setSelVal] = useState("")
  // useEffect(() => {
  //     setSelVal(lists[0]._id)
  // }, [lists])
  return (
    <>

      <span className="pl-3 influ_list_selector pt-0 d-inline-block">
        <Select
          placeholder="Select a list"
          name="influencerLists"
          showSearch
          defaultActiveFirstOption
          optionFilterProp="children"
          defaultValue={lists[0]._id}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
          }
          size="large"
          style={{ width: '100%' }}
          onChange={(e) => listOnChange(e)}
        >
          {/* <Option value="company">Company</Option> */}
          {
            lists.map(({ _id, listname }, index)=>(
              <Option key={_id+index}
                value={_id}>{listname}</Option>
            ))
          }
          {/* <Option value="60d618a4277417e69c376b56">dummy</Option> */}
        </Select>
      </span>
      {/* <span className="pr-3"> OR </span> */}
      {/* <Tooltip placement="bottomRight" title="Delete this active list">
                <span className="ml-2 influ_list--del d-inline-block">
                    <AiOutlineDelete/>
                </span>
            </Tooltip> */}
    </>
  );
};

export default InfluencerSelectControlComponent;
